module.exports = "<div id=\"chart\" class=\"chart-root\"></div>"